/**
 * Possible states of a given step
 */
export var SubwayNavNodeState;
(function (SubwayNavNodeState) {
    SubwayNavNodeState["NotStarted"] = "NotStarted";
    SubwayNavNodeState["Current"] = "Current";
    SubwayNavNodeState["CurrentWithSubSteps"] = "CurrentWithSubSteps";
    SubwayNavNodeState["Completed"] = "Completed";
    SubwayNavNodeState["ViewedNotCompleted"] = "ViewedNotCompleted";
    SubwayNavNodeState["Unsaved"] = "Unsaved";
    SubwayNavNodeState["Skipped"] = "Skipped";
    SubwayNavNodeState["Error"] = "Error";
    SubwayNavNodeState["WizardComplete"] = "WizardComplete";
})(SubwayNavNodeState || (SubwayNavNodeState = {}));
export const IconNames = {
    FullCircleMask: 'FullCircleMask',
    CompletedSolid: 'CompletedSolid',
    StatusErrorFull: 'StatusErrorFull',
    StatusError: 'StatusCircleErrorX',
    StatusCircleCheckMark: 'StatusCircleCheckMark', // for sub step
};
//# sourceMappingURL=subway-node.types.js.map